import { ReactComponent as IconURLName } from '@/assets/svgs/api-configuration_url-icon.svg'
import { ReactComponent as IconDropDownArrow } from '@/assets/svgs/button-dropdown.svg'
import { ReactComponent as IconAPIConfigDelete } from '@/assets/svgs/delete-api-config-icon.svg'
import { ReactComponent as IconAPIConfigWarn } from '@/assets/svgs/warn-api-config-icon.svg'
import Button from '@/components/Button'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index.js"
import Popover from '@/components/Popover/index'
import Toast2 from '@/components/Toast2'
import useModal from '@/hooks/use-modal/index'
import { useNavigate } from '@/lib/router-dom'
import api from '@/services/api/sourceSystemConfig.js'
import addFormats from "@/utils/custom-ajv-formats"
import rem from '@/utils/rem.js'
import Ajv from "ajv"
import { cloneDeep } from 'lodash'
import { useEffect, useRef, useState } from 'react'
import MultiClamp from 'react-multi-clamp'
import schema from '../../constants/configuration/schema.json'
import Tags from '@/componentsDS/Tags/Tags';
import { featureConstant } from '@/constants/configuration/feature'
import { useFeature } from '@/hooks/use-feature/index'
import PropTypes from "prop-types"

const ajv = new Ajv({ allErrors: true });
addFormats(ajv);
for (let k of Object.keys(schema.components.schemas))
    ajv.addSchema(schema.components.schemas[k], "#/components/schemas/" + k);

const TypeEnum = { "PROVIDE": "Provide", "RECEIVE": "Receive", "NOTIFY": "Notify", "NODE": "Comments/Status", "CREATE_PACKAGE": "Create Data Package", "CREATE_FOLDER": "Create Folder", "UPDATE_PACKAGE": "Update Data Package" }
const MappingEnum = { "DEFAULT": "Default mapping", "SINGLE": "Single mapping", "MULTI": "Custom mapping" }
const AuthEnum = { "NONE": "None", "API_KEY": "API Key", "JWT_SYM": "JWT (Symmetric)", "JWT": "JWT (Asymmetric)", "JWT_JWE": "JWT and JWE", "OAUTH": "Oauth" }

export default function MultiConfigList({ item, handleSubmit }) {
    const isCustomHeadersFeatureEnabled = useFeature(featureConstant.CUSTOM_HEADER_CONFIGURATION);
    
    const [filterVisible, setFilterVisible] = useState()
    const referenceRef = useRef(null)
    const { goTo } = useNavigate();

    const { visible: isVisible, show: showDeleteModal, hide: hideDeleteModal } = useModal()

    const [selectedConfigData, setSelectedConfigData] = useState(null)

    /*=================================================
        Error Modal
    /================================================*/
    const [error, setError] = useState()

    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick)
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick)
        }
    }, [])

    function handleDocumentClick(event) {
        if (!referenceRef.current || referenceRef.current.contains(event.target)) {
            return
        }
        setFilterVisible(false)
    }

    function goToPitstopToSourceSystem(data, type) {
        return goTo(`/configuration/api-configuration/pitstop-sourcesystem`, { data, type, sourceSystemId: item.id })
    }

    async function deletePitStopConfig() {
        hideDeleteModal()

        // if its delete is TPYE multi, update
        if (selectedConfigData?.type === 'MULTI' && selectedConfigData.endpoints && selectedConfigData.groupedItemKey) {
            let remaindingDE = Object.keys(selectedConfigData.endpoints).filter(s => {
                return JSON.stringify(selectedConfigData.endpoints[s]) !== selectedConfigData?.groupedItemKey
            });

            if (remaindingDE.length > 0) {
                const existingEndpoints = selectedConfigData?.endpoints;
                const remaindingEnpoitns = {};

                // keep only remaindingDE
                for (let deKey of remaindingDE) {
                    remaindingEnpoitns[deKey] = existingEndpoints[deKey]
                }

                const url = `${selectedConfigData.configType}/${item.id}`
                const [error] = await api.update(url, {
                    endpoints: remaindingEnpoitns,
                    type: 'MULTI'
                });

                if (error) {
                    return setError(error?.message || "Failed to update Pitstop Config")
                }

                handleSubmit()
                return;
            }
        }

        const [error, _result] = await api.remove(`${selectedConfigData.configType}/${item.id}`);
        if (error) {
            return setError(error?.message || "Failed to delete Pitstop config")
        }
        handleSubmit()
    }

    function editPitStopSourceSystem(data, type) {
        return goTo(`/configuration/api-configuration/pitstop-sourcesystem`, { data, type, mode: 'edit', sourceSystemId: item.id })
    }

    const list = (array) => {
        function validateData(json) {
            const validate = ajv.compile(schema.components.schemas.source_config);
            let copyOf = cloneDeep(json)
            delete copyOf?.configType
            const result = validate(copyOf);

            return result
        }

        const renderRow = (groupedItem, index, item = groupedItem) => {
            const groupedItemKey = groupedItem?.endpoints ? Object.keys(groupedItem?.endpoints)[0] : null;
            const isTransformRecord = !validateData(groupedItem);

            return (
                <div className="api-configuration__data-table__table__body__row" key={index}>
                    <div className="api-configuration__data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__body api-configurations__url-name">
                        <IconURLName />
                        {groupedItem.endpoint?.url && <span><MultiClamp clamp={3}>{groupedItem.endpoint?.url}</MultiClamp></span>}
                        {groupedItem.endpoints && <span><MultiClamp clamp={3}>{Object.values(groupedItem.endpoints)[0].url}</MultiClamp></span>}
                    </div>
                    <div className="api-configuration__data-table__table__body__content data-table__table__body__content--text data-table__body api-configuration__content__chip">
						<Tags label={TypeEnum[groupedItem.configType]} tagClassName="DS__tag--system" />
                    </div>
                    <div className="api-configuration__data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__body">
                        {MappingEnum[groupedItem.type]}
                        {isTransformRecord && (
                            " - Transform"
                        )}
                    </div>
                    <div className="api-configuration__data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__body">
                        {groupedItem?.endpoint?.auth && <span>{AuthEnum[groupedItem?.endpoint?.auth?.type]}</span>}
                        {groupedItem?.endpoints && <span>{AuthEnum[groupedItem?.endpoints?.[groupedItemKey]?.auth?.type]}</span>}
                    </div>
                    {(!isCustomHeadersFeatureEnabled && isTransformRecord) ?
                        <div className="api-configuration__data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--end" data-testid='row-menu-btn' /> :
                        <div className="api-configuration__data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--end" data-testid='row-menu-btn'>
                            {
                                <MultiLevelDropDown
                                    placement="bottom-start"
                                    menuList={[
                                        {
                                            label: "Edit",
                                            onClick: (e) => {
                                                e.stopPropagation();
                                                setSelectedConfigData(item)
                                                editPitStopSourceSystem({
                                                    ...item,
                                                    groupedItemKey,
                                                }, item.configType)
                                            },
                                        }, {
                                            label: "Delete",
                                            onClick: (e) => {
                                                e.stopPropagation();
                                                setSelectedConfigData({
                                                    ...item,
                                                    groupedItemKey,
                                                })
                                                showDeleteModal();
                                            },
                                        }]}
                                />
                            }
                        </div>
                    }
                </div >
            )
        }

        return array?.map((item, index) => {
            if (item.endpoints) {
                // For multiple endpoints show all unique value
                return [...new Set(Object.values(item.endpoints).map(s => JSON.stringify(s)))].map((s, endpointIndex) => {
                    let value = JSON.parse(s);
                    const uniqueKey = `${index}-endpoint-${endpointIndex}`;
                    return renderRow({ ...item, endpoints: { [s]: value } }, uniqueKey, item)
                })
            } else {
                return renderRow(item, `${index}-single`)
            }
        }).flat();
    };

    const DataLists = (item) => {
        let arrayLists = [];
        const apiConfigurationsList = item?.APIConfigurations;

        if (item?.notifyConfig) arrayLists.push(Object.assign(item?.notifyConfig, { configType: "NOTIFY" }))
        if (item?.provideConfig) arrayLists.push(Object.assign(item?.provideConfig, { configType: "PROVIDE" }))
        if (item?.receiveConfig) arrayLists.push(Object.assign(item?.receiveConfig, { configType: "RECEIVE" }))
        if (item?.nodeConfig) arrayLists.push(Object.assign(item?.nodeConfig, { configType: "NODE" }))
        if (item?.createPackageConfig) arrayLists.push(Object.assign(item?.createPackageConfig, { configType: "CREATE_PACKAGE" }))
        if (item?.createFolderConfig) arrayLists.push(Object.assign(item?.createFolderConfig, { configType: "CREATE_FOLDER" }))
        if (item?.updatePackageConfig) arrayLists.push(Object.assign(item?.updatePackageConfig, { configType: "UPDATE_PACKAGE" }))

        return (
            <>
                {arrayLists.length > 0 && <div className="source-system__data-table">
                    <div className="source-system__data-table__head-row">
                        <div className="data-table__table__head__title data-table__header source-system__data-table__url-heading">
                            URL
                        </div>
                        <div className="data-table__table__head__title data-table__header">
                            Type
                        </div>
                        <div className="data-table__table__head__title data-table__header">
                            Mapping
                        </div>
                        <div className="data-table__table__head__title data-table__header">
                            Authentication Type
                        </div>
                        <div className="data-table__table__head__title data-table__header data-table__table__head__title--end">
                        </div>
                    </div>
                    <div className="data-table__table__body">
                        {list(arrayLists)}
                    </div>
                </div>}
                {apiConfigurationsList?.length > 0 && <div className={arrayLists.length === 0 ? 'api-configuration__display-config-list' : 'api-configuration__display-config-lists'}>
                    <Popover visible={filterVisible} options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10], }, }, { name: 'flip', enabled: true, }] }} width="18%" placement="bottom">
                        <Popover.Trigger>
                            <span className='api-configuration__api-configuration-text' onClick={(e) => { e.stopPropagation(); setFilterVisible(!filterVisible) }}>+ Add API Configuration <IconDropDownArrow /></span>
                        </Popover.Trigger>
                        <Popover.Content>
                            <div ref={referenceRef}>
                                <div className="api-configuration__column__add__cols api-configuration__column__add__cols-popover">
                                    {(apiConfigurationsList.includes("PROVIDE") || apiConfigurationsList.includes("RECEIVE") || apiConfigurationsList.includes("NOTIFY")) && <div className='api-configuration__single-data-element-api'>Single Data Element APIs</div>}
                                    {apiConfigurationsList.includes("PROVIDE") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.provideConfig, "PROVIDE")}>
                                        <span>{"Provide"}</span>
                                    </div>}
                                    {apiConfigurationsList.includes("RECEIVE") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.receiveConfig, "RECEIVE")}>
                                        <span>{"Receive"}</span>
                                    </div>}
                                    {apiConfigurationsList.includes("NOTIFY") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.notifyConfig, "NOTIFY")}>
                                        <span>{"Notify"}</span>
                                    </div>}
                                    {(apiConfigurationsList.includes("PROVIDE") || apiConfigurationsList.includes("RECEIVE") || apiConfigurationsList.includes("NOTIFY")) && <hr />}
									{(apiConfigurationsList.includes("CREATE_FOLDER") || apiConfigurationsList.includes("CREATE_PACKAGE") || apiConfigurationsList.includes("UPDATE_PACKAGE") || apiConfigurationsList.includes("NODE")) && <div className='api-configuration__single-data-element-api'>Package APIs</div>}
                                    {apiConfigurationsList.includes("CREATE_FOLDER") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.createFolderConfig, "CREATE_FOLDER")}>
                                        <span>{"Create Folder"}</span>
                                    </div>}
                                    {apiConfigurationsList.includes("CREATE_PACKAGE") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.createPackageConfig, "CREATE_PACKAGE")}>
                                        <span>{"Create Data Package"}</span>
                                    </div>}
                                    {apiConfigurationsList.includes("UPDATE_PACKAGE") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.updatePackageConfig, "UPDATE_PACKAGE")}>
                                        <span>{"Update Data Package"}</span>
                                    </div>}
                                    {apiConfigurationsList.includes("NODE") && <div className="api-configuration__column__add__col" onClick={() => goToPitstopToSourceSystem(item.nodeConfig, "NODE")}>
                                        <span>{"Comments/Status"}</span>
                                    </div>}

                                </div>
                            </div>
                        </Popover.Content>
                    </Popover>
                </div>}
            </>
        )
    }

    return (
        <>
            {DataLists(item)}

            <Modal visible={isVisible} variant='medium' close={hideDeleteModal}>
                <CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconAPIConfigDelete />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Delete API Configuration
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div style={{ fontSize: rem(14), textAlign: 'center', marginTop: '48px' }}>Are you sure you want to delete API configuration?</div>
                            <div style={{ fontSize: rem(14), textAlign: 'center' }}>This action cannot be undone.</div>
                            <div className='multiple-config__display-flex'>
                                <div style={{ marginTop: '32px' }}><IconAPIConfigWarn /></div>
                                <div className='multiple-config-lists__delete-confirmation'>
                                    <div>Deleting the configuration will impact the data being </div>
                                    <div>shared/received from/to the source system.</div>
                                </div>
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Left>
                            <Button text="Cancel"
                                data-testid="cancel-button"
                                customeHover
                                btnText
                                submit={() => {
                                    hideDeleteModal();
                                }} />
                        </CardConfigure.Footer.Left>
                        <CardConfigure.Footer.Right>
                            <Button text="Delete"
                                data-testid="delete-button"
                                round
                                warning
                                submit={() => deletePitStopConfig()} />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Toast2 show={error} errorMessage={error} close={() => { setError() }} />
        </>
    )
}

MultiConfigList.propTypes = {
    item: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired
};
